export enum DynamicMyAccountTemplateModulesEnum {
	CHANGEEMAIL = 'changeEmail',
	COMPLETEPROFILE = 'completeProfile'
}
